import { supabase } from '../client/supabaseClient';

interface ShopInfo {
  id: string;
  shop_name: string;
  address: string;
  city: string;
  is_online: boolean;
  contact_info: string;
  location: string;
  shop_username: string;
}

/**
 * Get shop information by UUID
 * @param shopUuid - The shop UUID
 * @returns Shop information or null if not found
 */
export const getShopInfoByUuid = async (shopUuid: string): Promise<ShopInfo | null> => {
  try {
    const { data, error } = await supabase
      .schema('api')
      .rpc('get_shop_info_by_uuid', { shop_uuid: shopUuid });

    if (error) {
      console.error('Error fetching shop info:', error);
      return null;
    }

    return data;
  } catch (error) {
    console.error('Exception while fetching shop info:', error);
    return null;
  }
};
